import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {RequisitosGarantiasRespaldosOcupaciones} from "../_models/requisitos-garantias-respaldos-ocupaciones";

@Injectable({
  providedIn: 'root'
})
export class RequisitosGarantiasRespaldosOcupacionesService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldosOcupaciones';

  constructor(private httClient: HttpClient) { }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map(res => res as RequisitosGarantiasRespaldosOcupaciones[]));
  }

  busquedaRequisitoGarantiaRespaldo(idRequisitoGarantiaRespaldo: string) {
    return this.httClient.get(this.rutServicio + '/idRequisitoGarantiaRespaldo/' + idRequisitoGarantiaRespaldo + '/enabled').pipe(map(res => res as RequisitosGarantiasRespaldosOcupaciones[]));
  }

  bulk( registros: RequisitosGarantiasRespaldosOcupaciones[] ) {
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
